import { sendAxiosRequest } from '../../utils/sendRequest';
import { api } from '../../Api';
import UrlBuilder from '../../url/UrlBulder';
import IPayResponse from '../../../models/responces/IPayResponse';

export interface IApiPayPlanParams {
  id: number;
  period: 'month' | 'year';
}
const apiPayPlan = (params: IApiPayPlanParams) =>
  sendAxiosRequest({
    method: 'post',
    headers: { Authorization: api.getToken() },
    url: UrlBuilder.getURL({
      handler: 'plan',
      action: 'pay',
      id: params.id
    }),
    data: {
      period: params.period
    },
    responseType: 'json'
  }).then(resp => resp.data) as Promise<IPayResponse>;
export default apiPayPlan;
